"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propTypes = exports.defaultProps = exports.default = exports.NavigationCardDefaultContent = void 0;
require("./NavigationCardDefaultContent.css");
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _renderObject = require("../../util/renderObject/renderObject");
var _Icon = _interopRequireDefault(require("../Icon/Icon"));
var _LoaderGhostCard = _interopRequireDefault(require("../LoaderGhostCard/LoaderGhostCard"));
var _Text = _interopRequireDefault(require("../Text/Text"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * NavigationCardDefaultContent component
 *
 * @method
 * @param { NavigationCardDefaultContentProps } props
 * @returns NavigationCardDefaultContent
 */

const NavigationCardDefaultContent = props => {
  const {
    backgroundColor,
    borderColor,
    externalMediaElement,
    iconName,
    textOnlyLabel,
    actionLabel,
    isLoading = defaultProps.isLoading
  } = props;
  const componentClassName = (0, _classnames.default)('pal-c-NavigationCardDefaultContent', {});
  const componentStyle = {
    ...(backgroundColor && {
      '--backgroundColor': `var( --pal-colors-default-${backgroundColor} )`
    }),
    ...(borderColor && {
      '--borderColor': `var( --pal-colors-default-${borderColor} )`
    })
  };
  const renderContent = () => {
    if (isLoading) {
      return /*#__PURE__*/_react.default.createElement(_LoaderGhostCard.default, {
        variant: "textCircle"
      });
    } else {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)('pal-c-NavigationCardDefaultContent__circle', {
          'pal-c-NavigationCardDefaultContent--backgroundColor': backgroundColor,
          'pal-c-NavigationCardDefaultContent--borderColor': borderColor
        })
      }, externalMediaElement && /*#__PURE__*/_react.default.createElement("div", {
        className: "pal-c-NavigationCardDefaultContent__imageContainer"
      }, (0, _renderObject.renderObject)(externalMediaElement)), textOnlyLabel && /*#__PURE__*/_react.default.createElement(_Text.default, {
        htmlTag: "span",
        textStyle: "body",
        className: "pal-c-NavigationCardDefaultContent__textOnlyLabel"
      }, textOnlyLabel), iconName && /*#__PURE__*/_react.default.createElement("div", {
        className: "pal-c-NavigationCardDefaultContent__iconContainer"
      }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
        name: iconName,
        size: "custom"
      }))), actionLabel && /*#__PURE__*/_react.default.createElement("div", {
        className: "pal-c-NavigationCardDefaultContent__labelContainer"
      }, /*#__PURE__*/_react.default.createElement(_Text.default, {
        textAlign: "center",
        linkStyle: "textLinkSecondary",
        htmlTag: "span",
        className: "pal-c-NavigationCardDefaultContent__actionLabel"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "pal-c-NavigationCardDefaultContent__actionLabel--text"
      }, actionLabel))));
    }
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: componentClassName,
    style: componentStyle
  }, renderContent());
};

/**
 * Property type definitions
 * @typedef NavigationCardDefaultContentProps
 * @type {object}
 * @property {string} backgroundColor - Accepts background color to set for the NavigationCard circle container
 * @property {string} borderColor - Accepts border color to set for the NavigationCard circle container
 * @property {object} externalMediaElement - Accepts UltaAsset image from web-site
 * @property {string} iconName - Sets the name of the branded icon to render inside the Navigation card circle
 * @property {string} textOnlyLabel - Accepts text to display inside the Navigation card circle ( e.g. Shop all, View all )
 * @property {string} actionLabel - Accepts label text of the link from the web-site
 * @property {boolean} isLoading - Sets the loading state of the card
 */
exports.NavigationCardDefaultContent = NavigationCardDefaultContent;
const propTypes = exports.propTypes = {
  /**
   * Accepts background color to set for the NavigationCard circle container
   */
  backgroundColor: _propTypes.default.string,
  /**
   * Accepts border color to set for the NavigationCard circle container
   */
  borderColor: _propTypes.default.string,
  /**
   * Accepts UltaAsset image from web-site
   */
  externalMediaElement: _propTypes.default.object,
  /**
   * Sets the name of the branded icon to render inside the Navigation card circle
   */
  iconName: _propTypes.default.string,
  /**
   * Accepts text to display inside the Navigation card circle ( e.g. Shop all, View all )
   */
  textOnlyLabel: _propTypes.default.string,
  /**
   * Accepts label text of the link from the web-site
   */
  actionLabel: _propTypes.default.string,
  /**
   *  Loading state of the card
  */
  isLoading: _propTypes.default.bool
};

/**
 * Default values for passed properties
 *
 * @type {object}
 * @property {boolean} isLoading=false - sets the default loading state for the card
 */
const defaultProps = exports.defaultProps = {
  isLoading: false
};
NavigationCardDefaultContent.propTypes = propTypes;
var _default = exports.default = NavigationCardDefaultContent;